import { useCallback, useEffect, useRef, useState } from "react";

import { getSecondsUntilUTCDate } from "helper/dateHelper";

const ONE_SECOND_MS = 1000;

export const useCountdown = (expiresAt: string) => {
  const [seconds, setSeconds] = useState(() =>
    getSecondsUntilUTCDate(expiresAt),
  );
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const clearTimer = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);

  useEffect(() => {
    const initialSeconds = getSecondsUntilUTCDate(expiresAt);
    setSeconds(initialSeconds);

    if (initialSeconds > 0) {
      intervalRef.current = setInterval(() => {
        const currentSeconds = getSecondsUntilUTCDate(expiresAt);
        setSeconds(currentSeconds);

        if (currentSeconds <= 0) {
          clearTimer();
        }
      }, ONE_SECOND_MS);
    }

    return clearTimer;
  }, [expiresAt, clearTimer]);

  return { seconds };
};
